<span class="help-block text-danger" *ngIf="errorMessage !== null">{{errorMessage}}</span>
